import classNames from 'classnames'
import { useEffect, useRef } from 'react'
import s from './index.module.css'


const Textarea = ({
  className,
  error,
  style,
  onChange = e => { },
  inputRef,
  collapsed = false,
  collapsedHeight = 44,
  maxAutoHeight,
  ...props
}) => {
  const refTextarea = useRef()
  const refDiv = useRef()

  const setTextareaRef = node => {
    refTextarea.current = node
    if (typeof inputRef === 'function') {
      inputRef(node)
    } else if (inputRef) {
      inputRef.current = node
    }
  }

  const syncHeight = value => {
    let textarea = refTextarea.current
    let div = refDiv.current
    if (!textarea || !div) return

    if (collapsed) {
      textarea.style.height = collapsedHeight + 'px'
      textarea.style.overflowY = 'hidden'
      return
    }

    textarea.style.height = 'auto'
    div.style.width = textarea.clientWidth + 'px'
    div.innerText = value ?? ''
    let height = div.clientHeight
    const resolvedMaxHeight =
      Number.isFinite(Number(maxAutoHeight)) && Number(maxAutoHeight) > 0
        ? Number(maxAutoHeight)
        : null

    if (resolvedMaxHeight != null) {
      textarea.style.height = Math.min(height, resolvedMaxHeight) + 'px'
      textarea.style.overflowY =
        height > resolvedMaxHeight ? 'auto' : 'hidden'
      return
    }

    textarea.style.height = height + 'px'
    textarea.style.overflowY = 'hidden'
  }

  let func = e => {
    onChange(e)
    syncHeight(e?.target?.value ?? '')
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    syncHeight(props.value ?? '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, collapsed, collapsedHeight])

  return <div style={style} className={s.wrapper}>
    <textarea
      ref={setTextareaRef}
      onChange={func}
      className={classNames(s.textarea, { [className]: className }, { [s.error]: error })}
      style={
        collapsed
          ? {
              minHeight: `${collapsedHeight}px`,
              maxHeight: `${collapsedHeight}px`,
              overflowY: 'hidden',
            }
          : undefined
      }
      {...props}
    ></textarea>
    <div ref={refDiv} className={s.textarea}>{props.value}</div>
  </div>
}

export default Textarea
